module.exports = __webpack_public_path__ + "static/mainframe-future-6e9b4008ed80fcbe4c42979c072af6f5.png";